"use strict";
exports.__esModule = true;
require("jquery.fancybox/source/jquery.fancybox.css");
require("suggestions-jquery/dist/css/suggestions.min.css");
require("bootstrap/scss/bootstrap");
require("./../scss/main.scss");
var application_1 = require("./application");
var application = new application_1.Application();
application.run();
